import React, { FC, ReactNode, useState } from 'react';
import { Checkbox, Select } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { TOrganizationResponsePaginated, useLazyGetAdsOrganizationsQuery } from 'app/services/edpApiV1/moderator';
import { useDivisionsQuery } from 'app/services/edpApiV1/viewer';
import { FilterEmployees } from 'shared/types/news.types';
import style from './index.module.scss';

type TProps = {
  children?: ReactNode;
  field: FilterEmployees;
  divisionId: string | null;
  organizationId: string | null;
  onFieldChange: (data: FilterEmployees) => void;
  onOrganizationIdChange: (data: string | null) => void;
  onDivisionIdChange: (data: string | null) => void;
};

const SearchSettings: FC<TProps> = ({
  field,
  organizationId,
  divisionId,
  onFieldChange,
  onOrganizationIdChange,
  onDivisionIdChange,
}) => {
  const [withOrganization, setWithOrganization] = useState<boolean>(false);
  const { data } = useDivisionsQuery(null);

  const [organizations, setOrganizations] = useState<TOrganizationResponsePaginated>();

  const [getOrganizations] = useLazyGetAdsOrganizationsQuery();

  const onDivisionChange = (val: string) => {
    onFieldChange(val as FilterEmployees);
    onDivisionIdChange(null);
  };

  const onCheckboxChanged = async (e: CheckboxChangeEvent) => {
    setWithOrganization(e.target.checked);
    onOrganizationIdChange(null);
    if (e.target.checked) {
      setOrganizations(await getOrganizations({ search: '', page: 1, size: 100 }).unwrap());
    }
  };

  const setOrganization = (value: string) => {
    onOrganizationIdChange(value);
  };

  return (
    <div className={style.actions}>
      <div className={style['actions-top']}>
        <div className={style.field}>
          <b className={style['pick-field']}>Выберите поле для поиска</b>
          <Select
            defaultValue={FilterEmployees.EMPLOYEE}
            style={{ width: '100%' }}
            allowClear
            value={field}
            onChange={onDivisionChange}
            options={[
              { value: FilterEmployees.EMPLOYEE, label: FilterEmployees.EMPLOYEE },
              { value: FilterEmployees.DIVISION, label: FilterEmployees.DIVISION },
            ]}
          />
        </div>
        <div className={style.organization}>
          <Checkbox checked={withOrganization} onChange={onCheckboxChanged} className={style['change-orga-checbox']}>
            <b>Изменить организацию</b>
          </Checkbox>
          <Select
            style={{ width: '100%' }}
            allowClear
            value={organizationId}
            disabled={!withOrganization}
            onChange={setOrganization}
            options={organizations ? organizations?.data.map(org => ({ value: org.id, label: org.name })) : []}
          />
        </div>
      </div>
      {field === FilterEmployees.DIVISION ? (
        <div className={style['actions-bottom']}>
          <b>Выберите подразделение</b>
          <Select
            style={{ width: '100%' }}
            allowClear
            value={divisionId}
            onChange={onDivisionIdChange}
            options={data ? data.data.map(elem => ({ value: elem.id, label: elem.name })) : []}
          />
        </div>
      ) : null}
    </div>
  );
};

export default SearchSettings;
